import { getSession } from './supabase';
import { invokeEdgeFunction } from './edgeFunctions';
import { isRecord } from './errors';

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string' || !result.includes(',')) { reject(new Error('could not read the recording')); return; }
      resolve(result.slice(result.indexOf(',') + 1));
    };
    reader.onerror = () => reject(new Error('could not read the recording'));
    reader.readAsDataURL(blob);
  });
}
/** One transcription transport/parser for capture replay and ordinary dictated fields. */
export async function transcribeRecording(blob: Blob, ownerId: string): Promise<string> {
  const audioBase64 = await blobToBase64(blob);
  const format = blob.type.includes('mp4') ? 'mp4' : 'webm';
  const result = await invokeEdgeFunction('transcribe-audio', { audio_base64: audioBase64, format }, ownerId);
  const transcript = isRecord(result) && typeof result.text === 'string' ? result.text.trim() : '';
  if (!transcript) throw new Error('No speech was recognized; try again or type it.');
  const { data: { session } } = await getSession();
  if (!session || session.user.id !== ownerId) throw new Error('the signed-in account changed; transcription was not delivered');
  return transcript;
}
